import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import { Box, Card, Typography, Tabs, Tab } from "@mui/material";
import "react-phone-input-2/lib/bootstrap.css";
import ProfileSetup from "../../features/promocodes/AddPromo";
import Idproof from "../../features/tutor/Idproof";
import { useLocation } from "react-router-dom";
import { AddPromo } from "../../features";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const AddPromocode = () => {
  const [value, setValue] = useState<number>(0);
  const { state } = useLocation();
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (state?.tab) setValue(state?.tab);
  }, [state]);

  return (
    <MainContainer>
      <div className="main_loyout">
        <Card className="cards">
          <Box className="custom_tabs">
            <AddPromo />
          </Box>
        </Card>
      </div>
    </MainContainer>
  );
};

export default AddPromocode;
